<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated" v-if="serviceList">
      <div class="breadcrumb_con flex-display">
        <el-breadcrumb separator="/">
          <i class="el-icon-location-outline left icon-location"></i>
          <span class="left">{{ $t("common.CurrentLocation") }}：</span>
          <el-breadcrumb-item><router-link to="/Home">{{ $t("common.Glang") }}</router-link></el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t("top.Service") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-divider></el-divider>
      <img class="header_img" v-if="head_img" :src="img_head_url+head_img.src" />
      <div class="body_con">
        <div class="service_con">
          <div
            class="service_item"
            v-for="(item, index) in serviceList"
            :key="'service' + index"
          >
            <router-link :to="'/ServiceDetail?id=' + item.id"
              ><el-row :gutter="12">
                <el-col :span="8">
                  <div class="service_pic">
                    <img class="bg" src="../assets/img/news_bg.png" alt="" />
                    <img
                      class="img"
                      v-if="item.src"
                      :src="img_head_url + item.src"
                      :alt="item.title"
                    />
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="service_box">
                    <p class="service_title">
                      {{ item.title }}
                    </p>
                    <p class="service_time">{{item.create_time}}</p>
                    <p class="service_content">
                      {{ item.sub_title }}
                    </p>
                    <div class="service_detail flex-display">
                      <div class="more">
                        <i class="el-icon-arrow-right"></i
                        >{{ $t("common.ReadMore") }}
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row></router-link
            >
          </div>
          <el-pagination
            style="margin: 20px 0; text-align: center"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="limit"
            :total="count"
            background
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data () {
    return {
      loading: false,
      serviceList: [],
      page: 1,
      count: 0,
      limit: 6,
      img_head_url: '',
      head_img: '',
      lang: localStorage.lang || 'cn'
    }
  },
  created () {
    this.getServiceList()
  },
  methods: {
    getServiceList () {
      var that = this
      var json = {
        lang: that.lang,
        page: that.page
      }
      var url = '/api/get_services_list'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.count = res.data.count
          that.page = res.data.page
          that.serviceList = res.data.services_list
          that.img_head_url = res.img_head_url
          that.head_img = res.data.head_img
        }
      })
    },
    handleCurrentChange (val) {
      this.page = val
      this.getServiceList()
    }
  },
  mounted () {}
}
</script>
<style lang="less" scoped>
.service_con {
  width: 1200px;
  margin: 100px auto 60px;
  position: relative;
}
.service_item {
  display: block;
  width: 100%;
  margin-bottom: 60px;
  position: relative;
}
.service_item .service_pic {
  overflow: hidden;
  font-size: 0;
  position: relative;
  width: 100%;
}
.service_item .service_pic .bg {
  width: 100%;
  transition: all 0.3s;
}
.service_item .service_pic .img {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  max-width: 100%;
}
.service_item .service_pic:hover .img {
  transform: scale(1.1);
}
.service_box {
  margin-left: 60px;
  text-align: left;
}
.service_box .service_title {
  color: #333;
  margin: 0 0 18px 0;
  height: 30px;
  line-height: 30px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 22px;
}
.service_box .service_content {
  color: #333;
  margin: 18px 0;
  height: 30px;
  line-height: 30px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 16px;
}
.service_box .more {
  color: #fff;
  background-color: #3c427c;
  border: 1px solid #3c427c;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s;
}
.service_box .more i {
  margin-right: 5px;
}
.service_box .more:hover {
  color: #3c427c;
  background-color: #fff;
  border: 1px solid #3c427c;
}
.service_box .service_time {
  font-size: 16px;
  color: #303133;
}
// .body_con {
//   width: 1200px;
//   margin: 0 auto 20px;
//   position: relative;
//   text-align: left;
// }
// .service_icon {
//   width: 60px;
//   height: auto;
// }
// .new_more {
//   color: slateblue;
// }
</style>
